import { formatTopLevelDomainExtension } from "app/pages/sales-intelligence/sub-modules/advanced-search/helpers/common";

export const parseDomainExtensions = (input: string): string[] => {
    return input
        .split(/,\s*/)
        .filter((s) => s.trim().length > 0)
        .map(formatTopLevelDomainExtension);
};
